export enum FlowShapeType {
    RECTANGLE = "rectangle",
    PILL = "pill",
    DIAMOND = "diamond",
    PLACEHOLDER = "placeholder"
}
